import BaseController from "sap/mcsuite/controller/BaseController";
import { Translator } from "./Translator";
import BaseTranslator from "./BaseTranslator";
import Component from "sap/mcsuite/Component";

export default class FieldTranslator extends BaseTranslator implements Translator {

    constructor(component: Component) {
        super(component);
        this.argKeys = ['table_name', 'field_name'];
        this.translationTable = 'cfr_fielddev';
    }

    public async translate(...args: string[]): Promise<string> {
        const that = this as unknown as Component;
        return await that.translator.Field.getTranslationOrDefault(...args);
    }
}
